import {
  DocxException,
  createParagraph,
  createParagraphTitle,
  createParagraphWithCenter,
  createContentParagraph,
  createCombinationParagraphWithSpace,
  createEmptyLine,
  BOLD_TEXT,
  UNDERLINED_TEXT,
  UNDERLINED_BOLD_TEXT,
  RED_LINE_INDENT,
  createCombinationParagraph,
  SUPERSCRIPT_TEXT,
} from '../docxFunctions'
import { AlignmentType } from 'docx'
import {
  MNN_PARSE,
  P_MNN1,
  P_MNN2,
  P_MNN3,
  P_MNN4,
} from '@/store/const/lpParse'
import { createMnnTable } from '../allTables/createMnnTable'

// ТИПЫ МНН
export const DEFAULT_NAME = MNN_PARSE[P_MNN1].name
export const GROUPING_NAME = MNN_PARSE[P_MNN2].name
export const CHEMICAL_NAME = MNN_PARSE[P_MNN3].name
export const TRADE_NAME = MNN_PARSE[P_MNN4].name

const childSpace = '      '

/**
 * ПЕРВАЯ ЧАСТЬ ЗАКЛЮЧЕНИЯ до таблицы MnnTable
 */
export function createOneChapter(
  signerFIO,
  mnn,
  ath,
  form,
  reproducedLP,
  reproducedLPtext,
  isGNVLP,
  isVZN14,
  signerPosition,
  nameType,
  itemsMNN,
  CR
) {
  try {
    const superscriptParagraph = []
    CR.forEach((item, idx) => {
      superscriptParagraph.push(
        createCombinationParagraph([
          {
            type: SUPERSCRIPT_TEXT,
            content: `${CR[idx].tableKey}`,
          },
          {
            content: `Препарат включен в клинические рекомендации,${
              CR[idx].isApprovedNPS ? ' ' : ' не '
            }одобренные Научно-практическим Советом Министерства здравоохранения РФ и${
              CR[idx].isOnRubricator ? ' ' : ' не '
            }размещенные в информационной системе Министерства здравоохранения РФ «Рубрикатор клинических рекомендаций» (Клинические рекомендации «${
              CR[idx].name
            }» (КР ${CR[idx].crNumber ? CR[idx].crNumber : 'не определено'}); ${
              CR[idx].associations ? CR[idx].associations : 'не определено'
            }; ${CR[idx].year ? CR[idx].year + ' г.' : 'не определено'}).`,
            size: 22,
          },
        ])
      )
    })
    const options = { ...RED_LINE_INDENT }
    const createGNVLPParagraph = [
      isGNVLP
        ? createContentParagraph(
            '1.1. перечень жизненно необходимых и важнейших лекарственных препаратов для медицинского применения (далее - перечень жизненно необходимых и важнейших лекарственных препаратов);',
            options,
            { bold: true }
          )
        : createContentParagraph(
            '1.1. перечень жизненно необходимых и важнейших лекарственных препаратов для медицинского применения (далее - перечень жизненно необходимых и важнейших лекарственных препаратов);',
            options
          ),
    ]
    const createVZN14Paragraph = [
      isVZN14
        ? createContentParagraph(
            '1.2. перечень лекарственных препаратов, предназначенных для обеспечения лиц, больных гемофилией, муковисцидозом, гипофизарным нанизмом, болезнью Гоше, злокачественными  новообразованиями  лимфоидной, кроветворной и родственных им   тканей, рассеянным склерозом, гемолитико-уремическим синдромом, юношеским  артритом с системным началом, мукополисахаридозом I, II и VI типов, апластической   анемией неуточненной, наследственным дефицитом факторов II (фибриногена), VII (лабильного), X (Стюарта-Прауэра), лиц после трансплантации органов и (или) тканей  (далее - перечень дорогостоящих лекарственных препаратов).',
            options,
            { bold: true }
          )
        : createContentParagraph(
            '1.2. перечень лекарственных препаратов, предназначенных для обеспечения лиц, больных гемофилией, муковисцидозом, гипофизарным нанизмом, болезнью Гоше, злокачественными  новообразованиями  лимфоидной, кроветворной и родственных им   тканей, рассеянным склерозом, гемолитико-уремическим синдромом, юношеским  артритом с системным началом, мукополисахаридозом I, II и VI типов, апластической   анемией неуточненной, наследственным дефицитом факторов II (фибриногена), VII (лабильного), X (Стюарта-Прауэра), лиц после трансплантации органов и (или) тканей  (далее - перечень дорогостоящих лекарственных препаратов).',
            options
          ),
    ]
    return [
      createParagraph('В Комиссию Министерства здравоохранения', {
        alignment: AlignmentType.RIGHT,
      }),
      createParagraph('Российской Федерации по формированию ', {
        alignment: AlignmentType.RIGHT,
      }),
      createParagraph('перечней лекарственных препаратов', {
        alignment: AlignmentType.RIGHT,
      }),
      createParagraph('для медицинского применения и минимального ', {
        alignment: AlignmentType.RIGHT,
      }),
      createParagraph('ассортимента лекарственных препаратов, ', {
        alignment: AlignmentType.RIGHT,
      }),
      createParagraph('необходимых для оказания ', {
        alignment: AlignmentType.RIGHT,
      }),
      createParagraph('медицинской помощи', {
        alignment: AlignmentType.RIGHT,
        spacing: {
          after: 200,
        },
      }),
      createParagraphTitle('ЗАКЛЮЧЕНИЕ', { size: 24 }),
      createParagraphWithCenter(
        'по результатам оценки экономических последствий применения ' +
          'лекарственного препарата, изучения дополнительных последствий применения ' +
          'лекарственного препарата, а также оценки стоимости годового курса терапии',
        { size: 24 }
      ),
      createContentParagraph(
        '1. Настоящее заключение касается материалов, представленных для включения лекарственного препарата в следующие перечни:'
      ),
      // createCombinationParagraphWithSpace([
      //   {
      //     type: BOLD_TEXT,
      //     content:
      //       'для включения лекарственного препарата в следующие перечни:',
      //   },
      // ]),
      ...createGNVLPParagraph,
      ...createVZN14Paragraph,
      createEmptyLine(),
      createContentParagraph(
        '2. Информация об осуществляющих рассмотрение материалов сотрудниках федерального государственного бюджетного учреждения "Центр экспертизы и контроля   качества медицинской   помощи"   Министерства здравоохранения Российской Федерации (далее - Центр экспертизы) включает в себя:'
      ),
      createCombinationParagraphWithSpace([
        {
          content: '2.1. Фамилия, имя, отчество, должность: ',
        },
        {
          type: UNDERLINED_TEXT,
          content: `${signerFIO}`,
        },
        {
          type: UNDERLINED_TEXT,
          content: `, ${signerPosition || 'не определена'};`,
        },
      ]),
      createCombinationParagraphWithSpace(
        [
          {
            content: '2.2. Адрес Центра экспертизы: ',
          },
          {
            type: UNDERLINED_TEXT,
            content:
              '109028, г. Москва, Покровский бульвар, д. 6/20, стр. 2, телефон (факс): +7 (495) 783-19-05, электронная почта: office@rosmedex.ru',
          },
        ],
        { alignment: AlignmentType.START }
      ),
      createEmptyLine(),
      createContentParagraph(
        '3. Информация о лекарственном препарате включает в себя:'
      ),
      createCombinationParagraphWithSpace([
        {
          content: '3.1. наименование, в том числе:',
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            childSpace + '3.1.1. международное непатентованное наименование: ',
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === DEFAULT_NAME ? mnn : ''}`,
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === DEFAULT_NAME ? ';' : ''}`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            childSpace +
            '3.1.2. в случае отсутствия международного непатентованного наименования - группировочное наименование: ',
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === GROUPING_NAME ? mnn : ''}`,
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === GROUPING_NAME ? ';' : ''}`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            childSpace +
            '3.1.3. в случае отсутствия международного непатентованного или группировочного наименований - химическое наименование: ',
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === CHEMICAL_NAME ? mnn : ''}`,
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === CHEMICAL_NAME ? ';' : ''}`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            childSpace +
            '3.1.4. в случае отсутствия указанных наименований - торговое наименование: ',
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === TRADE_NAME ? mnn : ''}`,
        },
        {
          type: BOLD_TEXT,
          content: `${nameType === TRADE_NAME ? ';' : ''}`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            '3.2. код анатомо-терапевтическо-химической классификации лекарственного препарата: ',
        },
        {
          type: UNDERLINED_BOLD_TEXT,
          content: `${ath}`,
        },
        {
          type: UNDERLINED_BOLD_TEXT,
          content: `;`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            '3.3. предлагаемые к включению или исключению лекарственные формы зарегистрированного лекарственного препарата (необходимо перечислить): ',
        },
        {
          type: UNDERLINED_BOLD_TEXT,
          content: `${form}`,
        },
        {
          type: UNDERLINED_BOLD_TEXT,
          content: `;`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            '3.4. информацию о воспроизведенных или биоаналоговых (биоподобных) лекарственных препаратах (при наличии); ',
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          type: UNDERLINED_BOLD_TEXT,
          content: `${
            reproducedLP
              ? reproducedLPtext
              : 'нет воспроизведенных или биоаналоговых (биоподобных) лекарственных препаратов'
          }`,
        },
        {
          type: UNDERLINED_BOLD_TEXT,
          content: `;`,
        },
      ]),
      createCombinationParagraphWithSpace([
        {
          content:
            '3.5. информацию о лекарственных препаратах, включенных в перечни и имеющих аналогичные вносимым лекарственным препаратам показания к применению, а также применяющихся в аналогичных клинических ситуациях, с учетом клинических рекомендаций, утвержденных научно-практическим советом Министерства здравоохранения Российской Федерации:',
        },
      ]),
      ...(itemsMNN?.length
        ? [createMnnTable(itemsMNN), ...superscriptParagraph]
        : [
            createCombinationParagraphWithSpace([
              {
                type: UNDERLINED_BOLD_TEXT,
                content:
                  'лекарственные препараты с аналогичными показаниями отсутствуют;',
              },
            ]),
          ]),
      createEmptyLine(),
    ]
  } catch (err) {
    throw new DocxException(1, err.message)
  }
}
